import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { Trans } from 'react-i18next';

import { getSubscriptionTitle } from '../../helpers';

import * as S from '../styled';

interface IFeePriceRow {
    period: number | null;
    price: string;
    pricePerState: string;
    periodPerState: number | null;
}

const FeePriceRow = ({ period, price, pricePerState, periodPerState }: IFeePriceRow) => {
    const paymentLabel = getSubscriptionTitle(period, false);
    const perStateLabel = getSubscriptionTitle(periodPerState, false);

    return (
        <S.FeePriceRow>
            <Text type="medium-text">
                <Trans
                    i18nKey="subscription.commitment.period"
                    values={{
                        count: paymentLabel?.count,
                        context: paymentLabel?.context,
                    }}
                />
            </Text>
            <Text type="medium-text" className="text-right">
                {price}
                {pricePerState && (
                    <S.NotWrapBox>
                        <Trans
                            i18nKey="subscription.commitment.feePrice"
                            values={{
                                count: perStateLabel?.count,
                                context: perStateLabel?.context,
                                price: pricePerState,
                            }}
                        />
                    </S.NotWrapBox>
                )}
            </Text>
        </S.FeePriceRow>
    );
};

export default FeePriceRow;
